(function($){
    $(function(){

      
    });
  
  })(jQuery);